export default class AjaxLoader {
	constructor() {}

	static show() {
		let mask = document.querySelector('.mask');

		if (!mask)
			return;

		mask.classList.toggle('fade-in', true);
 	}

	static hide() {
		let mask = document.querySelector('.mask');

		if (!mask)
			return;

		mask.classList.toggle('fade-in', false);
 	}
}